<template>
  <div class="clearfix imageArray">
    <template v-for="video in videos">
      <b-list-group-item :href="video.VideoUrl" :key="video.id" class="no-hover border-none videoListItem mb3">
        <button @click="delete_video(video.id)" class="col-12 flex justify-between items-start gibson h6 line-height-2 border-none mx-auto white-background">
          <span class="left-align pr3">
            <span class="block semi-bold">Path</span>
            <span class="flex-auto left-align">{{video.VideoUrl}}</span>
          </span>
          <span class="px2 red">
            <i class="el-icon-delete"></i>
          </span>
        </button>
      </b-list-group-item>
    </template>
    <div class="col-12 videoDropZone">
      <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
    </div>
  </div>
</template>
<script>
import Dropzone from 'vue2-dropzone'
export default {
  name: 'profilevideo',
  props: ['videos'],
  components: {
    Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 101,
        createImageThumbnails: true,
        addRemoveLinks: true,
        acceptedFiles: '.mp4,.avi,.mpeg4,.flv,.3gpp',
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="40" height="40" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:18px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:15px;">Du kan kun uploade filer som er mp4, avi, mpeg4, flv, 3gpp, max. 100 000 KB</span></div>'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: ''
    }
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  methods: {
    'showSuccess': function (file) {
      this.$emit('Reload')
    },
    change_position (imageId, position) {
      this.$emit('moveImage', imageId, position)
    },
    delete_video (videoId) {
      this.$emit('delete_video', videoId)
    },
    edit_image (FileLocation, imageId) {
      this.$emit('edit_image', FileLocation, imageId)
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('operation', 'uploadVideo')
    }
  }
}
</script>



// WEBPACK FOOTER //
// profilevideo.vue?f2dce518